// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/fup-organisation-list-schema',
  type: 'object',
  required: [],
  nullable: true,
  properties: {
    id: {
      type: 'string',
      format: 'uuid',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    name: {
      type: 'string',
      nullable: true,
    },
    shortName: {
      type: 'string',
      nullable: true,
    },
    culture: {
      type: 'string',
      nullable: true,
    },
    languageIso2: {
      type: 'string',
      nullable: true,
    },
    district: {
      type: 'string',
      nullable: true,
    },
    region: {
      type: 'string',
      nullable: true,
    },
    country: {
      type: 'string',
      nullable: true,
    },
    category: {
      type: 'string',
      nullable: true,
    },
    orderNumber: {
      type: 'integer',
      nullable: true,
    },
    isPublicVisible: {
      type: 'boolean',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
